import React from "react";
import { ProgressBar } from "react-loader-spinner";
import { Modal } from "react-bootstrap";

import UniversalInputComponent from "../../AdministrativeProcedures/commonComponents/universalInputComponent/UniversalInputComponent";

import styles from "./modalWindowWithInputs.module.css";
import LoaderWithOverlay from "../loaderWithOverlay/loaderWithOverlay";

function ModalWindowWithInputs({
  data,
  handleSubmit,
  register,
  control,
  setValue,
  errors,
  clearErrors,
  showModal,
  setShowModal,
  inputsOptions,
  externalStyles,
  isLoadingModal,
  mode,
  handle,
  textButton,
  title = "",
}) {
  return (
    <Modal
      show={showModal}
      onHide={() => {
        setValue("pw", "");
        setShowModal(!showModal);
      }}
      centered
      backdrop="static"
      size="lg"
      fullscreen="lg-down">
      <Modal.Header
        closeButton
        className={styles["form-header"]}>
        <Modal.Title className={styles["form-title"]}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles["form-body"]}>
        <form
          className={styles["form-container"]}
          onSubmit={handleSubmit(handle)}>
          <UniversalInputComponent
            options={inputsOptions}
            mode={mode}
            styles={externalStyles}
            register={register}
            control={control}
            setValue={setValue}
            errors={errors}
            clearErrors={clearErrors}
            newData={data}
          />
          <div className={styles["form-footer"]}>
            <button
              className={styles.save_button}
              type={"submit"}
              value={"hh"}>
              {textButton}
            </button>
          </div>
        </form>
      </Modal.Body>
      <LoaderWithOverlay isLoading={isLoadingModal} />
    </Modal>
  );
}

export default ModalWindowWithInputs;
